/**
 * ============================================================================
 * EMPTY STATE COMPONENT - 100% Ready with Animations
 * ============================================================================
 */

import React from 'react';
import Button from './Button';

/**
 * Empty State Component
 * @param {Object} props
 * @param {string} props.title - Title text
 * @param {string} props.description - Description text
 * @param {React.ReactNode} props.icon - Icon component or emoji
 * @param {Object} props.action - Action button config { label, onClick, variant }
 * @param {string} props.className - Additional classes
 * @param {boolean} props.animate - Enable animations
 * @returns {JSX.Element}
 */
const EmptyState = ({ 
  title = 'No items found',
  description = 'Get started by creating your first item.',
  icon = '📭',
  action = null,
  className = '',
  animate = true
}) => {
  return (
    <div className={`text-center py-16 px-4 ${animate ? 'animate-fadeInUp' : ''} ${className}`}>
      {/* Icon */}
      <div className={`
        inline-block text-7xl mb-6
        ${animate ? 'animate-float' : ''}
      `}>
        {icon}
      </div>

      {/* Title */}
      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
        {title}
      </h3>

      {/* Description */}
      <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-md mx-auto text-lg">
        {description}
      </p>

      {/* Action Button */}
      {action && (
        <div className={animate ? 'animate-fadeInUp' : ''} style={{ animationDelay: '0.2s' }}>
          <Button
            variant={action.variant || 'primary'}
            onClick={action.onClick}
            size="lg"
            icon={action.icon}
            iconPosition={action.iconPosition || 'left'}
          >
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
